import { IProduct } from '@interfaces';

import styles from '@components/common/products/product.styles';
import { useEntity } from '@v2/store/rtk.entities.selectors';
import { useCallback, useMemo } from 'react';
import { useHistoryWithReferrer } from '@v2/utils/history';
import Procucts from '@img/pdp2/products.png'

export default function BundleShopOthers({ bundle }: { bundle?: IProduct }) {

    const history = useHistoryWithReferrer();
    const ageBundles = useEntity('ageBundles');
    const variety = useEntity('varietyPacks');
    const bundles = useMemo(() => {
        const age = ageBundles ? [...ageBundles].sort((a, b) => a.ageMin - b.ageMin) : [];
        const variery = variety || [];
        return getLinks(bundle, age, variery);
    }, [ageBundles])

    const getUrl = (bundle: IProduct) => {
        if(bundle.subcategory === 'age_bundle') {
           return `/bundle/age/${bundle.slug}`;
        }
        return `/bundle/variety/${bundle.slug}`;
    }
    const handleOpenBundle = useCallback((bundle: IProduct) => () => {
        history.goBack();
        setTimeout(() => {
            history.pushWithReferrer(getUrl(bundle));
        }, 200);
    }, [])

    return (
        <div className={styles.bundleShopOthers}>
            <h2>Shop other bundles</h2>
            <div className='container'>{bundles.map((bundle) => {
                return <a className="link" onClick={handleOpenBundle(bundle)} href={getUrl(bundle)}>
                    {bundle.subcategory === 'age_bundle' ? `${bundle.ageMin}${bundle.ageMax ? `-${bundle.ageMax}` : '+'} months` : bundle.title}
                </a>
            })}
            </div>
            <img className='products' src={Procucts} alt=''/>
        </div>
    );
}

const getLinks = (bundle: IProduct, ageBundles: IProduct[], varietyPacks: IProduct[]) => {
    switch(bundle.subcategory) {
        case 'age_bundle':
            const mainIndex = ageBundles.findIndex(ageBundle => ageBundle.id === bundle.id);
            if (mainIndex === -1) {
                return [];
            }
            const relatedBundles: IProduct[] = [];
            const addBundleIfNotExists = (bundleToAdd: IProduct) => {
                if (!relatedBundles.some(b => b.id === bundleToAdd.id)) {
                    relatedBundles.push(bundleToAdd);
                }
            };
            switch (mainIndex) {
                case 0: // 5-7 months
                    for (let i = 1; i <= 4; i++) {
                        addBundleIfNotExists(ageBundles[mainIndex + i]);
                    }
                    relatedBundles.push(...varietyPacks.slice(0, 2)); // Add 2 Variety Packs
                    break;
                case 1: // 8-9 months
                    addBundleIfNotExists(ageBundles[mainIndex - 1]); // 5-7 months
                    for (let i = 1; i <= 3; i++) {
                        addBundleIfNotExists(ageBundles[mainIndex + i]);
                    }
                    relatedBundles.push(...varietyPacks.slice(0, 2)); // Add 2 Variety Packs
                    break;
                case 2: // 10-11 months
                    addBundleIfNotExists(ageBundles[mainIndex - 1]); // 8-9 months
                    addBundleIfNotExists(ageBundles[mainIndex + 1]); // 12-14 months
                    for (let i = 1; i <= 3; i++) {
                        addBundleIfNotExists(ageBundles[mainIndex + i]);
                    }
                    relatedBundles.push(...varietyPacks.slice(0, 2)); // Add 2 Variety Packs
                    break;
                case 3: // 12-14 months
                    addBundleIfNotExists(ageBundles[mainIndex - 1]); // 10-11 months
                    addBundleIfNotExists(ageBundles[mainIndex + 1]); // 15-17 months
                    for (let i = 1; i <= 3; i++) {
                        addBundleIfNotExists(ageBundles[mainIndex + i]);
                    }
                    relatedBundles.push(...varietyPacks.slice(0, 2)); // Add 2 Variety Packs
                    break;
                case 4: // 15-17 months
                    addBundleIfNotExists(ageBundles[mainIndex - 1]); // 12-14 months
                    addBundleIfNotExists(ageBundles[mainIndex + 1]); // 18-20 months
                    for (let i = 1; i <= 3; i++) {
                        addBundleIfNotExists(ageBundles[mainIndex + i]);
                    }
                    relatedBundles.push(...varietyPacks.slice(0, 2)); // Add 2 Variety Packs
                    break;
                case 5: // 18-20 months
                    addBundleIfNotExists(ageBundles[mainIndex - 1]); // 15-17 months
                    addBundleIfNotExists(ageBundles[mainIndex + 1]); // 21-24 months
                    addBundleIfNotExists(ageBundles[mainIndex + 2]); // 25+ months
                    relatedBundles.push(...varietyPacks.slice(0, 4)); // Add 4 Variety Packs
                    break;
                case 6: // 21-24 months
                    addBundleIfNotExists(ageBundles[mainIndex - 2]); // 15-17 months
                    addBundleIfNotExists(ageBundles[mainIndex - 1]); // 18-20 months
                    addBundleIfNotExists(ageBundles[mainIndex + 1]); // 25+ months
                    relatedBundles.push(...varietyPacks.slice(0, 4)); // Add 4 Variety Packs
                    break;
                case 7: // 25+ months
                    addBundleIfNotExists(ageBundles[mainIndex - 3]); // 15-17 months
                    addBundleIfNotExists(ageBundles[mainIndex - 2]); // 18-20 months
                    addBundleIfNotExists(ageBundles[mainIndex - 1]); // 21-24 months
                    relatedBundles.push(...varietyPacks.slice(0, 4)); // Add 4 Variety Packs
                    break;
            }
            return relatedBundles;
        case 'variety_pack':
            return varietyPacks?.slice?.(0, 5).filter(varietyPack => varietyPack.id !== bundle.id) ?? [];
        default:
            return [];
    }
}